import { render } from "./ImportSales.vue?vue&type=template&id=8080ddb2"
import script from "./ImportSales.vue?vue&type=script&lang=js"
export * from "./ImportSales.vue?vue&type=script&lang=js"

import "./ImportSales.vue?vue&type=style&index=0&id=8080ddb2&lang=css"
script.render = render

export default script